// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"c3dc8480","123":"2a52d213","312":"664ed6a4","746":"cd836c7a","929":"7ad840fe","992":"3256b2b3"}[chunkId] + ".chunk.js";
};